import React from 'react';

const Footer = () => (
  <div className="footer" style={{ textAlign: 'center' }}>
    <a href="https://beian.miit.gov.cn">
      <p>津ICP备2023003571号</p>
    </a>
  </div>
);

export default Footer;
